import { render, staticRenderFns } from "./ImportCategory.vue?vue&type=template&id=d41a2524&scoped=true&"
import script from "./ImportCategory.vue?vue&type=script&lang=js&"
export * from "./ImportCategory.vue?vue&type=script&lang=js&"
import style1 from "./ImportCategory.vue?vue&type=style&index=1&id=d41a2524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41a2524",
  null
  
)

export default component.exports